import React from "react";
import { motion } from "motion/react";

const Timelinetext = ({ title, description }) => {
  return (
    <div className="col-span-4 w-full h-full">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: false, amount: 0.5 }}
        className="w-full h-full rounded-md p-2 my-10 md:pl-4"
      >
        <h2 className="text-speed-red lg:text-4xl font-bold md:text-2xl sm:text-lg max-sm:text-lg  py-2 ">
          {title}
        </h2>
        <p className="text-speed-red sm:text-sm text-xs">{description}</p>
      </motion.div>
    </div>
  );
};

export default Timelinetext;
